import * as R from 'ramda'

export function sortByDepartureTime<T extends Record<'departureTime', string>>(list: T[]): T[] {
  return R.sortBy(R.prop('departureTime'))(list)
}
